import React from 'react';
import { Button } from 'src/components/atoms';
import {
  MessageInputBox,
  MessageInputContainer,
} from './ReportMessages.styles';

interface Props {
  draftMessage: string;
  updateDraftMessage: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  sendMessage: () => void;
  isAssigneeOrHasSentMessage: boolean;
}

export const MessageInput = ({
  updateDraftMessage,
  sendMessage,
  draftMessage,
  isAssigneeOrHasSentMessage,
}: Props) => {
  return (
    <MessageInputContainer>
      <MessageInputBox
        autoFocus
        data-testid="case-message-box-input"
        onChange={updateDraftMessage}
        value={draftMessage || ''}
        placeholder={
          isAssigneeOrHasSentMessage
            ? 'Type a message...'
            : 'If you choose to message the reporter, we will inform the reporter that you entered the chat'
        }
      />

      <Button
        onClick={sendMessage}
        data-testid="case-message-send"
        variant="primary"
        disabled={!draftMessage}
        width="100%"
      >
        Send Message
      </Button>
    </MessageInputContainer>
  );
};
